import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../images/logo.jpg';
import './Footer.css';

const YEAR = new Date().getFullYear();

function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="footer" aria-label="Site footer">
      <div className="footer-inner">
        {/* ---- Brand column ---- */}
        <div className="footer-col--brand">
          <Link to="/" className="footer-brand" aria-label="Twinkle Toes Schools">
            <img src={logoImg} alt="Twinkle Toes Schools logo" width="48" height="48" />
            <span>Twinkle Toes Schools</span>
          </Link>
          <p className="footer-tagline">
            Empowering young minds with a balanced blend of academic and personal growth.
          </p>
          <p className="footer-tagline" style={{ fontStyle: 'italic', marginTop: 4 }}>
            Sure Steps to Greatness.
          </p>
          <div className="footer-social" aria-label="Social media links">
            {/* Facebook */}
            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noreferrer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
              </svg>
            </a>
            {/* Instagram */}
            <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noreferrer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
                <rect x="2" y="2" width="20" height="20" rx="6"/>
                <circle cx="12" cy="12" r="4.2"/>
                <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none"/>
              </svg>
            </a>
            {/* WhatsApp */}
            <a href="https://wa.me/2348012345678" aria-label="WhatsApp" target="_blank" rel="noreferrer">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.126.556 4.119 1.528 5.845L0 24l6.335-1.652A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.883 0-3.634-.518-5.124-1.416l-.366-.218-3.78.985 1.013-3.675-.239-.383A9.94 9.94 0 0 1 2 12c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* ---- Quick Links ---- */}
        <div className="footer-col">
          <p className="footer-heading">Quick Links</p>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/news">News & Events</Link></li>
            <li><Link to="/admissions">Admissions</Link></li>
          </ul>
        </div>

        {/* ---- Support ---- */}
        <div className="footer-col">
          <p className="footer-heading">Support</p>
          <ul className="footer-links">
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/admissions">Apply Now</Link></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>

        {/* ---- Contact ---- */}
        <div className="footer-col">
          <p className="footer-heading">Contact</p>
          <div className="footer-contact">
            <p>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="var(--secondary-container)" opacity=".22"/>
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" stroke="var(--secondary-container)" strokeWidth="1.5" strokeLinejoin="round"/>
                <circle cx="12" cy="9" r="2.5" fill="var(--secondary-container)"/>
              </svg>
              Cajaah Estate, Orozo, Abuja
            </p>
            <p>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 12a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1.84h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              <a href="tel:+2348012345678">+234 801 234 5678</a>
            </p>
            <p>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <a href="mailto:info@twinkletoesschools.com">info@twinkletoesschools.com</a>
            </p>
          </div>
        </div>
      </div>

      {/* ---- Bottom bar ---- */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>© {YEAR} Twinkle Toes Schools. Sure Steps to Greatness.</p>
          <button onClick={scrollToTop} className="back-to-top" aria-label="Back to top">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>
            Back to top
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
